// @flow
import * as React from 'react';
import { Box } from 'grommet';

type Props = {
    children: React.Node,
}

const UpperContainer = (props: Props) => {
    const { children } = props;
    return (
        <Box
            pad={{ horizontal: 'small', vertical: '0px' }}
            flex={{ shrink: 0 }}
        >
            { children }
        </Box>
    );
};
export default UpperContainer;
